import { OPENING_CONFIGURATION_TYPE } from 'app/typings/core/admin/experiences/enum/openingConfiguration';
import type { ExtranetHotelExperience } from 'app/typings/core/extranet/hotel/experiences';
import type { ExtranetHotelPack } from 'app/typings/core/extranet/hotel/packs';

export const hasExperiencePrice = (
  pack: ExtranetHotelPack,
  experience?: ExtranetHotelExperience
): boolean => {
  const config = experience?.openingConfiguration?.priceConfiguration;

  if (!config) {
    return false;
  }

  const priceKeys = pack.isDaytime
    ? { adult: 'daytimePrice' as const }
    : { adult: 'price' as const };

  if (config.type === OPENING_CONFIGURATION_TYPE.CONSTANT) {
    return !!config.configuration[priceKeys.adult];
  }

  if (config.type === OPENING_CONFIGURATION_TYPE.DAILY) {
    return Object.values(config.days).some((d) => !!d[priceKeys.adult]);
  }

  return false;
};
